import { teadsApi } from './teads-api';

export let clickThroughOverrideUrl: string | undefined;

export function setupClickThroughOverride() {
  teadsApi.getContextData((e, ctx) => {
    if (ctx && ctx.tracking && /\S+/.test(ctx.tracking.click_through_override)) {
      clickThroughOverrideUrl = ctx.tracking.click_through_override;
    }
  });
}

export function replaceClickThrough(url: string) {
  return clickThroughOverrideUrl || url;
}
